import { Input, Modal, message } from "antd";
import { ReactNode } from "react";

type ConfirmActionOptions = {
    title: string;
    content: ReactNode;
    okText?: string;
    cancelText?: string;
    okType?: "primary" | "default" | "danger";
};

type ConfirmTypedActionOptions = {
    title: string;
    description: ReactNode;
    expectedValue: string;
    inputLabel?: string;
    okText?: string;
    cancelText?: string;
};

export function showSuccess(content: ReactNode) {
    message.success(content);
}

export function showError(content: ReactNode) {
    message.error(content);
}

export function showWarning(content: ReactNode) {
    message.warning(content);
}

export function showInfo(content: ReactNode) {
    message.info(content);
}

export function confirmAction({
    title,
    content,
    okText = "Confirm",
    cancelText = "Cancel",
    okType = "primary",
}: ConfirmActionOptions) {
    return new Promise<boolean>((resolve) => {
        Modal.confirm({
            title,
            content,
            okText,
            cancelText,
            okType,
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
        });
    });
}

export function confirmTypedAction({
    title,
    description,
    expectedValue,
    inputLabel,
    okText = "Confirm",
    cancelText = "Cancel",
}: ConfirmTypedActionOptions) {
    let confirmationValue = "";

    return new Promise<boolean>((resolve) => {
        Modal.confirm({
            title,
            okText,
            cancelText,
            okType: "danger",
            content: (
                <div>
                    <div style={{ marginBottom: 12 }}>{description}</div>
                    <div style={{ marginBottom: 8 }}>
                        {inputLabel || `Type "${expectedValue}" to confirm.`}
                    </div>
                    <Input onChange={(event) => { confirmationValue = event.target.value; }} />
                </div>
            ),
            onOk: () => {
                if (confirmationValue !== expectedValue) {
                    showError(`Please type "${expectedValue}" to confirm.`);
                    return Promise.reject(new Error("Typed confirmation mismatch"));
                }
                resolve(true);
            },
            onCancel: () => resolve(false),
        });
    });
}
